export const SUCCESS = '#19be6b'
export const WARNING = '#ff9900'